module.exports = __webpack_public_path__ + "img/jan-4.2b2c25fc.jpg";